<template>
  <div class="admin admin-public-part-lot" v-if="bid">
    <p class="admin-title a-flex-start a-align-items-center">

      {{$t('form.lot.lot-title', {number: lot.id})}}
      <button class="gui-btn gui-btn--white-border gui-btn--w-230 u-margin-left-20">{{$t('buttons.save-lot-to-favorites')}}</button>
      <router-link :to="{name: 'purchases-my-lots-details', params: { lotId: lot.id, tab: 'overview'}}"
                   class="gui-btn gui-btn--red gui-btn--w-300 u-margin-left-20">
        На публичную страницу закупки
      </router-link>
    </p>

    <div class="a-tab" id="accordion-tab">
      <div class="a-tab__control">
        <router-link to="overview" tag="button" type="button" class="a-tab__btn" active-class="a-active " >{{$t('form.lot.basic-data')}}</router-link>

        <template v-if="lot.request && lot.request.permissions.HAS_ACCREDITATION" >
          <router-link to="request" tag="button" type="button" class="a-tab__btn" active-class="a-active " v-if="lot.request.state.EMPTY">{{$t('form.lot.send-request')}}</router-link>
          <router-link to="request" tag="button" type="button" class="a-tab__btn" active-class="a-active " v-else>{{$t('form.lot.request')}} {{lot.catalog.name}}-{{lot.request.id}}</router-link>
        </template>

        <router-link to="discussion" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('form.lot.lot-discussion')}}</router-link>

        <template v-for="bidItem in lot.request.bids">
          <router-link v-if="bidItem.historical"
                       :key="bidItem.id"
                       :to="{
                         params: {
                           lotId: lot.id,
                           requestId: lot.request.id,
                           bidId: bidItem.id,
                           tab: 'bid'
                         }
                       }"
                       class="a-tab__btn"
                       active-class="a-active" >
            {{$t('form.lot.bid', {id: bidItem.num})}}
            <div class="font-weight-bold">
              от <date-time tag="span" :value="bidItem.sentTime"></date-time>
            </div>
          </router-link>
          <router-link v-else
                       :key="bidItem.id"
                       :to="{
                         params: {
                           lotId: lot.id,
                           requestId: lot.request.id,
                           bidId: bidItem.id,
                           tab: 'bid'
                         }
                       }"
                       class="a-tab__btn"
                       active-class="a-active" >
            {{$t('form.lot.bid', {id: bidItem.num})}}
            <div class="font-weight-bold">
              Текущее
            </div>
          </router-link>
        </template>

<!--        <router-link to="bid" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('form.lot.bid', {id: bid.num})}}</router-link>-->
      </div>

      <div class="collapse show" data-parent="#accordion-tab" data-target="#collapse-tab1" aria-labelledby="heading-tab1" aria-expanded="true">
        <form class="human-data">
          <!-- Overview tab -->
          <template v-if="showOverview">
            <overview :lot="lot" ></overview>
            <documents :lot="lot" v-if="showDocuments"></documents>
            <protocols :lot="lot" v-if="showProtocols"></protocols>
            <requests :lot="lot" v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_ALL_REQUESTS"></requests>
          </template>

          <lot-specification :lot="lot" v-if="showSpecification"></lot-specification>

          <!-- Request tab -->
          <template v-if="showRequest">
            <my-request :lot="lot" v-if="lot.request.permissions.HAS_ACCREDITATION" ></my-request>
          </template>

          <lot-discussion :lot="lot" v-if="showDiscussion"></lot-discussion>

          <!--<template v-for="bid in bids" >-->
          <bid-overview :lot="lot" :bid="bid" v-if="showBid"></bid-overview>-
          <!--</template>-->
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  import Overview from './Overview'
  import Documents from './Documents'
  import Protocols from './Protocols'
  import MyRequest from './MyRequest'
  import Requests from './Requests'
  import LotDiscussion from './LotDiscussion'
  import BidOverview from './BidOverview'
  import BidInRequest from './request/BidInRequest';
  import LotSpecification from './LotSpecification'

  export default {
    props: {
      lot: Object,
      bidId: Number,
      historical: {
        type: Boolean,
        default: false
      }
    },

    components: {
      BidInRequest,
      Overview,
      Documents, Protocols, MyRequest, Requests, LotDiscussion, BidOverview,LotSpecification
    },

    computed: {
      showOverview() {
        return this.$route.params.tab === 'overview';
      },

      showDocuments() {
        return this.$route.params.tab === 'overview';
      },

      showProtocols() {
        return this.$route.params.tab === 'overview' && this.lot.permissions.CAN_SEE_PUBLIC_LOT_PROTOCOLS;
      },

      showRequest() {
        return this.$route.params.tab === 'request'
      },

      showDiscussion() {
        return this.$route.params.tab === 'discussion'
      },

      showSpecification() {
        return this.$route.params.tab === 'specification'
      },

      bid() {
        return _.find(this.lot.request.bids, { id: this.bidId });
      },

      showBid() {
        return this.$route.params.tab === 'bid';
      },

      requestedBid() {
        return this.$route.params.tab;
      }
    },

    created() {
      if (this.showRequest && !this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST) {
        // user has not required permission, let's redirect to overview tab
      }

      if (this.showDiscussion && !this.lot.permissions.CAN_SEE_PUBLIC_LOT_COMMENTS) {
        // user has not required permission, let's redirect to overview tab
      }

      // if (this.isBidRequested && (!this.showBid || !this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST)) {
      //   // user has not required permission, let's redirect to overview tab
      // }
    }
  }
</script>

<style>
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }
</style>
